/*
author:you 2015-1-7
 */
"use strict";
angular.module("mangeProSiteServiceModule", [])
    .controller("mangeProSiteModCtrl", ["$scope", "$modalInstance", "$stateParams", "params", "productMangageMentWebsiteService", "trsHttpService", "modalDialog", function($scope, $modalInstance, $stateParams, params, productMangageMentWebsiteService, trsHttpService, modalDialog) {
        initStatus();
        // console.log(params);
        $scope.cancel = function() {
            $modalInstance.dismiss("cancel");
        };
        $scope.confirm = function() {
            if ($scope.isSiteExist == '"true"') {
                modalDialog.alertType("该站点名已经存在", "", "error", false);
                return;
            }
            if ($scope.examEng == 'false') {
                modalDialog.alertType("存放位置已存在", "", "error", false);
                return;
            }
            $scope.newsite.SiteName = $scope.newsite.SiteDesc;
            $scope.newsite.SiteOrder = $scope.allSitesSelected.value;
            $scope.newsite.ObjectId = angular.isDefined($scope.newsite.ObjectId) ? parseInt($scope.newsite.ObjectId) : 0;
            $scope.newsite.TempId = JSON.stringify({
                "CHNLTEMPID": angular.isDefined($scope.temp) ? parseInt($scope.temp.TEMPID) : 0,
                "OTHERTEMPID": angular.isDefined($scope.otherTemp) ? parseInt($scope.otherTemp.TEMPID) : 0,
                "DOCTEMPID": angular.isDefined($scope.xilanTemp) ? parseInt($scope.xilanTemp.TEMPID) : 0,
            });
            $scope.newsite.CKMSIMDAYRANGE = isNaN($scope.newsite.CKMSIMDAYRANGE) ? 0 : $scope.newsite.CKMSIMDAYRANGE;
            $scope.newsite.repeatUseTime = $scope.newsite.repeatUseTime === '' ? 0 : $scope.newsite.repeatUseTime;
            if($scope.isJudge&&$scope.newsite.ISORIGINAL=='0'){
                deleteProducts();
            }
            $modalInstance.close($scope.newsite);
        };
        function deleteProducts(){
            let params = {
                serviceid: 'mlf_originalgroup',
                methodname: 'deleteProduct',
                PRODUCTID: parseInt($scope.newsite.ObjectId),
                MEDIATYPE: 2
            }
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(),params,'get').then(function(data){

            });
        }
        /**
         * [queryTemplate description]模板弹窗打开
         * @param  {[type]} TEMPLATETYPE [description]
         * @return {[type]}              [description]
         */
        function queryTemplate(TEMPLATETYPE, TEMP, temp) {
            var params = {
                ObjectType: "103",
                ObjectId: $scope.newsite.ObjectId,
                TEMPLATETYPE: TEMPLATETYPE,
                TempName: '',
                selectedTempName: temp.TEMPNAME,
                selectedTempId: temp.TEMPID,
            };
            productMangageMentWebsiteService.bindTemplate(params, function(result) {
                $scope[TEMP] = result;
            });
        }
        /**
         * [channlViews description]站点首页模板点击
         * @return {[type]} [description]
         */
        $scope.channlViews = function(temp) {
            queryTemplate(1, "temp", temp);
        };
        /**
         * [channlOtherViews description]其他首页模板点击
         * @return {[type]} [description]
         */
        $scope.channlOtherViews = function(temp) {
            queryTemplate(1, "otherTemp", temp);
        };
        /**
         * [defaultArticleViews description]默认文章模板点击
         * @return {[type]} [description]
         */
        $scope.defaultArticleViews = function(temp) {
            queryTemplate(2, "xilanTemp", temp);
        };
        //检查是否检查稿件属性
        $scope.checkAttr = function(type) {
            if (type == "CheckFgdAttribute") {
                $scope.newsite.CheckFgdAttribute = $scope.newsite.CheckFgdAttribute === 1 ? 0 : 1;
            } else if (type == "Ispaichong") {
                $scope.newsite.Ispaichong = $scope.newsite.Ispaichong === 1 ? 0 : 1;
            }
        };
        $scope.examineEngName = function() {
            var examParams = {
                serviceid: "mlf_websiteconfig",
                methodname: "checkWebSitePath",
                DataPath: $scope.newsite.DataPath
            };
            examParams.SiteId = angular.isDefined($scope.newsite.siteId) ? $scope.newsite.siteId : 0;
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), examParams, "get").then(function(data) {
                $scope.examEng = data;
            });
        };

        /**
         * [checkSiteName description] 校验站点名是否已经存在
         * @return {[type]} [description]
         */
        $scope.checkSiteName = function() {
            if ($scope.newsite.SiteDesc == $scope.thisSiteName || $scope.newsite.SiteDesc === "") {
                $scope.isSiteExist = false;
                return;
            }
            var params = {
                serviceid: "mlf_appconfig",
                methodname: "checkSiteNameExists",
                SITENAME: $scope.newsite.SiteDesc,
                SITEID: $scope.thisSiteId || "0"
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.isSiteExist = data;
            });
        };
        /** [description] 补足ngchange时间存在的缺陷 */
        $scope.$watch("isSiteExist", function() {
            if ($scope.newsite.SiteDesc === "") {
                $scope.isSiteExist = false;
            }
        });
        /** [initStatus description] 初始化状态 */
        function initStatus() {
            //console.log(params);
            $scope.title = params.title;
            $scope.allSites = [];
            $scope.isSiteExist = '"false"'; //校验站点名是否已经存在
            $scope.examEng = 'true'; //校验存放位置是否已经存在
            angular.forEach(params.allSite, function(data, index, array) {
                $scope.allSites.push({
                    name: data.SITEDESC,
                    value: data.SITEORDER
                });
            });
            $scope.allSites.unshift({
                name: "最前面",
                value: -1
            });
            $scope.isJudge = false;
            if (params.siteInfo !== "") {
                $scope.newsite = params.siteInfo;
                $scope.temp = params.siteInfo.temp;
                $scope.otherTemp = params.siteInfo.otherTemp;
                $scope.xilanTemp = params.siteInfo.xilanTemp;
                $scope.thisSiteName = params.SiteName;
                $scope.thisSiteId = params.ObjectId;
                //处理编辑站点排序默认选中站点开始
                $scope.isJudge = $scope.newsite.ISORIGINAL == '1';
                var i = 0;
                while (i < $scope.allSites.length) {
                    //去除本站点在排序列表上展现，并且将本站点的前一个站点设为默认位置。
                    if ($scope.allSites[i].value === params.siteInfo.SiteOrder) {
                        $scope.allSites.splice(i, 1);
                        $scope.allSitesSelected = angular.copy($scope.allSites[i - 1]);
                    } else {
                        i++;
                    }
                }
            } else {
                $scope.allSitesSelected = angular.copy($scope.allSites[0]);
                $scope.newsite = {
                    CheckFgdAttribute: 0,
                    Ispaichong: 0,
                    repeatUseTime: 0,
                    CKMSIMDAYRANGE: 0,
                    ISORIGINAL: 1,
                };
            }
        }
    }]);